import { useSyncExternalStore } from 'react'
import { Snackbar } from './Snackbar'
import styles from './SnackbarContainer.module.scss'
import { store } from './store'
import { type Notification } from './types'

const serverSnapshot: Notification[] = []
export const SnackbarContainer = () => {
  const items = useSyncExternalStore(store.subscribe, store.read, () => serverSnapshot)

  return (
    <div className={styles['pintxo-snackbar-container']}>
      {items.map((item) => (
        <Snackbar
          {...item}
          key={item.id}
          className={item.isFading ? 'pintxo-snackbar--leaving' : ''}
          onDismiss={() => store.delete(item.id)}
          label={item.label}
        />
      ))}
    </div>
  )
}
